let total: number = 0;

let changeCallback: any[] = [];

function setTotal(data: any) {
  total = data;
  changeCallback.forEach((item) => item(total));
}

function listenDataChange(callback: (num: number) => void = () => {}) {
  changeCallback.push(callback);
}

function MessageTotalCountPublish() {
  // 订阅
  function subscribe(callback: (num: number) => void) {
    listenDataChange(callback);
  }
  // 发布
  function publish(num: number) {
    setTotal(num);
  }
  // 取消订阅
  function remove(callback: (num: number) => void) {
    changeCallback = changeCallback.filter((item) => item !== callback);
  }

  return { subscribe, publish, remove };
}

export default MessageTotalCountPublish;
